import React from "react";
import { Link } from "react-router-dom";

/**
 * Circular Medical Peptide Store brand-mark — Feb-2026 header-only asset.
 *
 * Isolated from `components/brand/Logo.jsx` (rectangular wordmark still
 * used by the homepage hero and the footer) so this treatment cannot
 * bleed into those surfaces.
 *
 * Rules:
 *   * Never AI-regenerate, crop, or overlay text on the source image.
 *   * Always `object-contain` so nothing distorts on odd aspect ratios.
 *   * Alt text remains the exact brand name.
 */
export const HEADER_LOGO_SRC =
  "https://customer-assets-jt897jd0.emergentagent.net/job_tender-goldberg-9/artifacts/c4i2ni55_ChatGPT%20Image%20Aug%2026%2C%202026%2C%2009_45_53%20PM.png";

export const HeaderLogo = ({ className = "" }) => (
  <Link
    to="/"
    data-testid="site-logo"
    className={`inline-flex items-center group shrink-0 ${className}`}
    aria-label="Medical Peptide Store — home"
  >
    <img
      src={HEADER_LOGO_SRC}
      alt="Medical Peptide Store"
      data-testid="header-logo-img"
      loading="eager"
      decoding="async"
      draggable="false"
      // Prominent square footprint per the Feb-2026 header spec:
      //   * mobile   ~ 72 px square
      //   * desktop  ~ 100 px square
      // object-contain guarantees no distortion regardless of natural
      // aspect ratio.
      className="block object-contain select-none group-hover:opacity-90 transition-opacity h-[72px] w-[72px] md:h-[96px] md:w-[96px] lg:h-[100px] lg:w-[100px]"
    />
  </Link>
);
